/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Edit_With_AiInputs */



/**
* | output |
* | --- |
* | "Edit with AI" |
*
* @param {Artifact_Edit_With_AiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_edit_with_ai = /** @type {((inputs?: Artifact_Edit_With_AiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Edit_With_AiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit KI bearbeiten")
	return /** @type {LocalizedString} */ ("Edit with AI")
});